import { render } from "./Spop.vue?vue&type=template&id=6e92d460&scoped=true"
import script from "./Spop.vue?vue&type=script&lang=js"
export * from "./Spop.vue?vue&type=script&lang=js"

import "./Spop.vue?vue&type=style&index=0&id=6e92d460&scoped=true&lang=css"

import exportComponent from "D:\\My Project\\NewBlog\\WEB\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e92d460"]])

export default __exports__